import React, { memo } from 'react';

import { brand, title, urlEspecial, urlAssets, urlPortadaEspeciales } from '../../Constants'; 

const Footer = () => {
    return (
        <footer className="postal-footer">
            <section className="text-center">
                <a href={urlEspecial}>
                    <img className="img-fluid logo-negro" src={`${urlAssets}/img/enviar-mas.png`} alt={title} />
                </a>
            </section>          
            <section className="mt-3 mt-md-5 text-center">
                <a href={urlPortadaEspeciales} target="blank">
                    <img className="img-fluid" src={`${urlAssets}/img/especiales-multimedia.png`} alt={`Especiales ${brand}`} />
                </a>
            </section>    
        </footer>
    )
}

export default memo(Footer);
